<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [draggable]="false" 
  header="Maintenance Notice" [style]="{ width: '500px' }">
  <div class="maintenance-dialog-content">
    <p class="maintenance-message">
      eSTM-Cloud will shut down for end-of-day scheduled maintenance in exactly <strong>{{ displayMinutes }}:{{ displaySeconds | number: '2.0-0' }}</strong> minutes. 
      Please save all your tasks and log out.
    </p>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="OK" (click)="onOkClick()" class="p-button-primary"></button>
  </ng-template>
</p-dialog>
